<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Gider Tanımı
    </div>
    <template v-if="dataItem.donation_group">
      <div>{{ dataItem.donation_group }}</div>
      <div class="text-warning font-small-2">
        {{ dataItem.main_group }}
      </div>
      <div class="d-flex justify-content-between">
        <b-badge
          variant="light-warning"
        >
          {{ dataItem.donation_type }}
        </b-badge>
        <b-badge
          :variant="dataItem.id_account_types === '1'? 'light-success' : 'light-danger'"
        >
          {{ dataItem.account_type }}
        </b-badge>
      </div>
    </template>
    <template v-else>
      <div class="text-muted">
        Belirtilmedi
      </div>
    </template>
  </b-list-group-item>
</template>
<script>
import { BBadge, BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'DonationGroup',
  components: {
    BBadge,
    BListGroupItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
